import React from 'react';
import { motion } from 'framer-motion';
import VideoBackground from './VideoBackground';

export default function CinematicGrid() {
  const videos = [
    { src: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0508%20(1).mov", label: "Ceremony Moment" },
    { src: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0516(1).mov", label: "Estate Details" },
    { src: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0520.mov", label: "Garden Views" },
    { src: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0520(5).mov", label: "Reception Atmosphere" },
    { src: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0526%20(1).mov", label: "Golden Hour" },
    { src: "https://ik.imagekit.io/aeu02xvjgn/Summer%20Promotion/0606%20(1).mov", label: "Nighttime Romance" }
  ];

  return (
    <section className="py-24 bg-ivory">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-gold uppercase tracking-[0.3em] text-xs mb-4 block">The Experience</span>
          <h2 className="text-4xl md:text-5xl text-olive mb-6">Carefully Planned. Beautifully Experienced.</h2>
          <div className="w-12 h-[1px] bg-gold mx-auto opacity-40"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {videos.map((video, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="relative aspect-[4/5] md:aspect-square overflow-hidden group bg-ivory-dark"
            >
              <VideoBackground 
                src={video.src} 
                overlayOpacity="bg-black/20 group-hover:bg-black/40 transition-all duration-700"
              />
              <div className="absolute inset-x-0 bottom-0 p-8 transform translate-y-4 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                <span className="text-white font-serif text-xl md:text-2xl tracking-wide">{video.label}</span>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}